import * as React from 'react';
import PropTypes from 'prop-types';
import LinearProgress from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import {useEffect, useState} from "react";
import {ApiUrl} from "./portal-urls";
import {handleHttpResponse} from "./http-helpers";

function LinearProgressWithLabel(props) {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box sx={{ width: '80%', mr: 1 }}>
                <LinearProgress variant="determinate" {...props} />
            </Box>
            <Box sx={{ minWidth: 35}}>
                <Typography variant="body2" color="text.secondary" fontSize='1vh'>{`${Math.round(
                    props.value,
                )}%`}</Typography>
            </Box>
        </Box>
    );
}

LinearProgressWithLabel.propTypes = {
    /**
     * The value of the progress indicator for the determinate and buffer variants.
     * Value between 0 and 100.
     */
    value: PropTypes.number.isRequired,
};

export default function BatchProgressLinearWithLabel(props) {
    const batchId = props.batchId || "";

    const [progress, setProgress] = useState(0);

    useEffect(() => {

        batchId && getProgress(batchId);

    }, [])

    const getProgress = async (id) => {
        const url = ApiUrl.Batch.getBatchById.getPath(id);
        try {
            const res = await fetch(url).then(handleHttpResponse);
            setProgress(res.progress);
        } catch (err) {
            console.error(err);
        }
    }

    return (
        <Box sx={{ width: '100%' }}>
            <LinearProgressWithLabel value={progress} />
        </Box>
    );
}
